module.exports = __webpack_public_path__ + "img/standing.fb3cd020.svg";